module.exports = __webpack_public_path__ + "static/img/jcICON1.4fc03da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/data/jcICON1.png
// module id = X123
// module chunks = 49